import { configureStore } from "@reduxjs/toolkit"

import {
  alert,
  cs,
  visitor,
} from "./reducers";

const store = configureStore({
  reducer: {
    alert,
    cs,
    visitor,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export default store;